export const GP_UPSELL = 'gp-upsell'
export const GP_CTA = 'gp-CTA'
export const GP_UPSELL_ITEM = 'gp-upsell-item'

export const TC_LINK = 'tc-link'
